import policy from '../config/addressQuality.json';
const patterns = policy.placeholderPatterns.map(pattern => new RegExp(pattern, 'i'));
export const isPlaceholderAddress = address => patterns.some(pattern => pattern.test(String(address || '').trim()));
export const isMultipleStreetAddress = address => new RegExp(policy.multipleStreetPattern, 'i').test(String(address || ''));
export const unavailableAddressLabel = policy.unavailableLabel;
export function addressLocality(da) {
  if (da?.suburb) return String(da.suburb).trim();
  if (!isPlaceholderAddress(da?.address)) return '';
  return String(da.address).split(',').slice(1).join(',').trim().replace(/\s*(?:NSW\s*\d{4}|\d{4}\s*NSW|NSW)\s*$/i, '').trim();
}
